var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { StakeProgram, SystemProgram, SYSVAR_CLOCK_PUBKEY, SYSVAR_RENT_PUBKEY, SYSVAR_STAKE_HISTORY_PUBKEY, } from "@solana/web3.js";
import { findBSolTokenAccountAuthority, findEpochReportAccount, findGSolMintAuthority, findMSolTokenAccountAuthority, findOrderUnstakeTicketAccount, getValidatorIndex, } from "./util.js";
import { MarinadeUtils, } from "@sunrisestake/marinade-ts-sdk";
import { utils } from "@coral-xyz/anchor";
import { TOKEN_PROGRAM_ID } from "@solana/spl-token";
import BN from "bn.js";
import { STAKE_POOL_PROGRAM_ID } from "./constants.js";
// export type EpochReportAccount =
//   IdlAccounts<SunriseStake>["epochReportAccount"];
export var deposit = function (config, program, marinade, marinadeState, stateAddress, staker, recipientGsolTokenAccount, lamports) { return __awaiter(void 0, void 0, void 0, function () {
    var sunriseStakeState, marinadeProgram, gsolMintAuthority, msolTokenAccountAuthority, msolAssociatedTokenAccountAddress, liqPoolAssociatedTokenAccountAddress, accounts;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, program.account.state.fetch(stateAddress)];
            case 1:
                sunriseStakeState = _b.sent();
                marinadeProgram = marinade.marinadeFinanceProgram.programAddress;
                gsolMintAuthority = findGSolMintAuthority(config)[0];
                msolTokenAccountAuthority = findMSolTokenAccountAuthority(config)[0];
                return [4 /*yield*/, utils.token.associatedAddress({
                        mint: marinadeState.mSolMintAddress,
                        owner: msolTokenAccountAuthority,
                    })];
            case 2:
                msolAssociatedTokenAccountAddress = _b.sent();
                return [4 /*yield*/, utils.token.associatedAddress({
                        mint: marinadeState.lpMint.address,
                        owner: msolTokenAccountAuthority,
                    })];
            case 3:
                liqPoolAssociatedTokenAccountAddress = _b.sent();
                _a = {
                    state: stateAddress,
                    marinadeState: marinadeState.marinadeStateAddress,
                    gsolMint: sunriseStakeState.gsolMint,
                    gsolMintAuthority: gsolMintAuthority,
                    msolMint: marinadeState.mSolMint.address,
                    liqPoolMint: marinadeState.lpMint.address
                };
                return [4 /*yield*/, marinadeState.solLeg()];
            case 4:
                _a.liqPoolSolLegPda = _b.sent(),
                    _a.liqPoolMsolLeg = marinadeState.mSolLeg;
                return [4 /*yield*/, marinadeState.mSolLegAuthority()];
            case 5:
                _a.liqPoolMsolLegAuthority = _b.sent();
                return [4 /*yield*/, marinadeState.lpMintAuthority()];
            case 6:
                _a.liqPoolMintAuthority = _b.sent();
                return [4 /*yield*/, marinadeState.reserveAddress()];
            case 7:
                _a.reservePda = _b.sent(),
                    _a.transferFrom = staker,
                    _a.mintMsolTo = msolAssociatedTokenAccountAddress,
                    _a.mintLiqPoolTo = liqPoolAssociatedTokenAccountAddress,
                    _a.mintGsolTo = recipientGsolTokenAccount;
                return [4 /*yield*/, marinadeState.mSolMintAuthority()];
            case 8:
                accounts = (_a.msolMintAuthority = _b.sent(),
                    _a.msolTokenAccountAuthority = msolTokenAccountAuthority,
                    _a.systemProgram = SystemProgram.programId,
                    _a.tokenProgram = TOKEN_PROGRAM_ID,
                    _a.marinadeProgram = marinadeProgram,
                    _a);
                return [2 /*return*/, program.methods.deposit(lamports).accounts(accounts).transaction()];
        }
    });
}); };
export var depositStakeAccount = function (config, program, marinade, marinadeState, staker, stakeAccountAddress, stakerGsolTokenAccount) { return __awaiter(void 0, void 0, void 0, function () {
    var stateAddress, sunriseStakeState, marinadeProgram, gsolMintAuthority, msolTokenAccountAuthority, msolAssociatedTokenAccountAddress, stakeAccountInfo, voterAddress, validatorSystem, stakeSystem, accounts, validatorIndex;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                stateAddress = config.stateAddress;
                return [4 /*yield*/, program.account.state.fetch(stateAddress)];
            case 1:
                sunriseStakeState = _b.sent();
                marinadeProgram = marinade.marinadeFinanceProgram.programAddress;
                gsolMintAuthority = findGSolMintAuthority(config)[0];
                msolTokenAccountAuthority = findMSolTokenAccountAuthority(config)[0];
                return [4 /*yield*/, utils.token.associatedAddress({
                        mint: marinadeState.mSolMintAddress,
                        owner: msolTokenAccountAuthority,
                    })];
            case 2:
                msolAssociatedTokenAccountAddress = _b.sent();
                return [4 /*yield*/, MarinadeUtils.getParsedStakeAccountInfo(marinade.provider, stakeAccountAddress)];
            case 3:
                stakeAccountInfo = _b.sent();
                voterAddress = stakeAccountInfo.voterAddress;
                if (!voterAddress) {
                    throw new Error("The stake account must be delegated");
                }
                validatorSystem = marinadeState.state.validatorSystem;
                stakeSystem = marinadeState.state.stakeSystem;
                _a = {
                    state: stateAddress,
                    marinadeState: marinadeState.marinadeStateAddress,
                    gsolMint: sunriseStakeState.gsolMint,
                    gsolMintAuthority: gsolMintAuthority,
                    validatorList: validatorSystem.validatorList.account,
                    stakeList: stakeSystem.stakeList.account,
                    stakeAccount: stakeAccountAddress
                };
                return [4 /*yield*/, marinadeState.validatorDuplicationFlag(voterAddress)];
            case 4:
                _a.duplicationFlag = _b.sent(),
                    _a.stakeAuthority = staker,
                    _a.msolMint = marinadeState.mSolMint.address,
                    _a.mintMsolTo = msolAssociatedTokenAccountAddress,
                    _a.mintGsolTo = stakerGsolTokenAccount;
                return [4 /*yield*/, marinadeState.mSolMintAuthority()];
            case 5:
                accounts = (_a.msolMintAuthority = _b.sent(),
                    _a.msolTokenAccountAuthority = msolTokenAccountAuthority,
                    _a.clock = SYSVAR_CLOCK_PUBKEY,
                    _a.rent = SYSVAR_RENT_PUBKEY,
                    _a.stakeProgram = StakeProgram.programId,
                    _a.systemProgram = SystemProgram.programId,
                    _a.tokenProgram = TOKEN_PROGRAM_ID,
                    _a.marinadeProgram = marinadeProgram,
                    _a);
                return [4 /*yield*/, getValidatorIndex(marinadeState, voterAddress)];
            case 6:
                validatorIndex = _b.sent();
                return [2 /*return*/, program.methods
                        .depositStakeAccount(validatorIndex)
                        .accounts(accounts)
                        .transaction()];
        }
    });
}); };
export var getEpochReportAccount = function (config, program) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, address, bump, account;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = findEpochReportAccount(config), address = _a[0], bump = _a[1];
                return [4 /*yield*/, program.account.epochReportAccount.fetchNullable(address)];
            case 1:
                account = _b.sent();
                return [2 /*return*/, {
                        address: address,
                        bump: bump,
                        account: account,
                    }];
        }
    });
}); };
// TODO move this into the client to avoid having to pass in so many things?
export var liquidUnstake = function (config, blaze, marinade, marinadeState, program, stateAddress, staker, stakerGsolTokenAccount, lamports) { return __awaiter(void 0, void 0, void 0, function () {
    var sunriseStakeState, marinadeProgram, gsolMintAuthority, msolTokenAccountAuthority, msolAssociatedTokenAccountAddress, liqPoolAssociatedTokenAccountAddress, bsolTokenAccountAuthority, bsolAssociatedTokenAddress, accounts;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, program.account.state.fetch(stateAddress)];
            case 1:
                sunriseStakeState = _b.sent();
                marinadeProgram = marinade.marinadeFinanceProgram.programAddress;
                gsolMintAuthority = findGSolMintAuthority(config)[0];
                msolTokenAccountAuthority = findMSolTokenAccountAuthority(config)[0];
                return [4 /*yield*/, utils.token.associatedAddress({
                        mint: marinadeState.mSolMintAddress,
                        owner: msolTokenAccountAuthority,
                    })];
            case 2:
                msolAssociatedTokenAccountAddress = _b.sent();
                return [4 /*yield*/, utils.token.associatedAddress({
                        mint: marinadeState.lpMint.address,
                        owner: msolTokenAccountAuthority,
                    })];
            case 3:
                liqPoolAssociatedTokenAccountAddress = _b.sent();
                bsolTokenAccountAuthority = findBSolTokenAccountAuthority(config)[0];
                return [4 /*yield*/, utils.token.associatedAddress({
                        mint: blaze.bsolMint,
                        owner: bsolTokenAccountAuthority,
                    })];
            case 4:
                bsolAssociatedTokenAddress = _b.sent();
                _a = {
                    state: stateAddress,
                    marinadeState: marinadeState.marinadeStateAddress,
                    msolMint: marinadeState.mSolMint.address,
                    liqPoolMint: marinadeState.lpMint.address,
                    gsolMint: sunriseStakeState.gsolMint,
                    gsolMintAuthority: gsolMintAuthority
                };
                return [4 /*yield*/, marinadeState.solLeg()];
            case 5:
                _a.liqPoolSolLegPda = _b.sent(),
                    _a.liqPoolMsolLeg = marinadeState.mSolLeg;
                return [4 /*yield*/, marinadeState.mSolLegAuthority()];
            case 6:
                accounts = (_a.liqPoolMsolLegAuthority = _b.sent(),
                    _a.treasuryMsolAccount = marinadeState.treasuryMsolAccount,
                    _a.getMsolFrom = msolAssociatedTokenAccountAddress,
                    _a.getMsolFromAuthority = msolTokenAccountAuthority,
                    _a.getLiqPoolTokenFrom = liqPoolAssociatedTokenAccountAddress,
                    _a.gsolTokenAccount = stakerGsolTokenAccount,
                    _a.gsolTokenAccountAuthority = staker,
                    _a.systemProgram = SystemProgram.programId,
                    _a.tokenProgram = TOKEN_PROGRAM_ID,
                    _a.rent = SYSVAR_RENT_PUBKEY,
                    _a.marinadeProgram = marinadeProgram,
                    _a.bsolTokenAccount = bsolAssociatedTokenAddress,
                    _a.bsolAccountAuthority = bsolTokenAccountAuthority,
                    _a.blazeStakePool = blaze.pool,
                    _a.stakePoolWithdrawAuthority = blaze.withdrawAuthority,
                    _a.reserveStakeAccount = blaze.reserveAccount,
                    _a.managerFeeAccount = blaze.feesDepot,
                    _a.bsolMint = blaze.bsolMint,
                    _a.sysvarStakeHistory = SYSVAR_STAKE_HISTORY_PUBKEY,
                    _a.stakePoolProgram = STAKE_POOL_PROGRAM_ID,
                    _a.nativeStakeProgram = StakeProgram.programId,
                    _a.clock = SYSVAR_CLOCK_PUBKEY,
                    _a);
                return [2 /*return*/, program.methods
                        .liquidUnstake(lamports)
                        .accounts(accounts)
                        .transaction()];
        }
    });
}); };
export var triggerRebalance = function (config, marinade, marinadeState, program, stateAddress, payer) { return __awaiter(void 0, void 0, void 0, function () {
    var sunriseStakeState, marinadeProgram, msolTokenAccountAuthority, msolAssociatedTokenAccountAddress, liqPoolAssociatedTokenAccountAddress, epochInfo, _a, epochReportAccount, epochReportAccountAddress, index, _b, orderUnstakeTicketAccount, orderUnstakeTicketAccountBump, accounts, instruction;
    var _c;
    var _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0: return [4 /*yield*/, program.account.state.fetch(stateAddress)];
            case 1:
                sunriseStakeState = _e.sent();
                marinadeProgram = marinade.marinadeFinanceProgram.programAddress;
                msolTokenAccountAuthority = findMSolTokenAccountAuthority(config)[0];
                return [4 /*yield*/, utils.token.associatedAddress({
                        mint: marinadeState.mSolMintAddress,
                        owner: msolTokenAccountAuthority,
                    })];
            case 2:
                msolAssociatedTokenAccountAddress = _e.sent();
                return [4 /*yield*/, utils.token.associatedAddress({
                        mint: marinadeState.lpMint.address,
                        owner: msolTokenAccountAuthority,
                    })];
            case 3:
                liqPoolAssociatedTokenAccountAddress = _e.sent();
                return [4 /*yield*/, program.provider.connection.getEpochInfo()];
            case 4:
                epochInfo = _e.sent();
                return [4 /*yield*/, getEpochReportAccount(config, program)];
            case 5:
                _a = _e.sent(), epochReportAccount = _a.account, epochReportAccountAddress = _a.address;
                // If the epoch report account has not yet been created, then the upgrade_authority has to create it
                // with the initEpochReport instruction
                if (!epochReportAccount)
                    throw new Error("No epoch report account found");
                index = (_d = epochReportAccount.tickets.toNumber()) !== null && _d !== void 0 ? _d : 0;
                _b = findOrderUnstakeTicketAccount(config, BigInt(epochInfo.epoch), BigInt(index)), orderUnstakeTicketAccount = _b[0], orderUnstakeTicketAccountBump = _b[1];
                _c = {
                    state: stateAddress,
                    payer: payer,
                    marinadeState: marinadeState.marinadeStateAddress,
                    gsolMint: sunriseStakeState.gsolMint,
                    msolMint: marinadeState.mSolMint.address,
                    liqPoolMint: marinadeState.lpMint.address
                };
                return [4 /*yield*/, marinadeState.solLeg()];
            case 6:
                _c.liqPoolSolLegPda = _e.sent(),
                    _c.liqPoolMsolLeg = marinadeState.mSolLeg;
                return [4 /*yield*/, marinadeState.mSolLegAuthority()];
            case 7:
                _c.liqPoolMsolLegAuthority = _e.sent();
                return [4 /*yield*/, marinadeState.lpMintAuthority()];
            case 8:
                _c.liqPoolMintAuthority = _e.sent(),
                    _c.liqPoolTokenAccount = liqPoolAssociatedTokenAccountAddress;
                return [4 /*yield*/, marinadeState.reserveAddress()];
            case 9:
                accounts = (_c.reservePda = _e.sent(),
                    _c.treasuryMsolAccount = marinadeState.treasuryMsolAccount,
                    _c.getMsolFrom = msolAssociatedTokenAccountAddress,
                    _c.getMsolFromAuthority = msolTokenAccountAuthority,
                    _c.orderUnstakeTicketAccount = orderUnstakeTicketAccount,
                    _c.epochReportAccount = epochReportAccountAddress,
                    _c.systemProgram = SystemProgram.programId,
                    _c.tokenProgram = TOKEN_PROGRAM_ID,
                    _c.clock = SYSVAR_CLOCK_PUBKEY,
                    _c.rent = SYSVAR_RENT_PUBKEY,
                    _c.marinadeProgram = marinadeProgram,
                    _c);
                return [4 /*yield*/, program.methods
                        .triggerPoolRebalance(new BN(epochInfo.epoch), new BN(index), orderUnstakeTicketAccountBump)
                        .accounts(accounts)
                        .instruction()];
            case 10:
                instruction = _e.sent();
                return [2 /*return*/, {
                        instruction: instruction,
                        orderUnstakeTicketAccount: orderUnstakeTicketAccount,
                        epochReportAccount: epochReportAccountAddress,
                    }];
        }
    });
}); };
//# sourceMappingURL=../../src/dist/marinade.js.map